import React, { useEffect, useState } from "react";
import SimpleBar from "simplebar-react";
import moment from "moment";

import { serviceGetLivechatTicketTranscript } from "services/livechat";

// Read-only transcript of a Live Chat ticket, through CRM-03 (same scope as the
// Live Chat inbox). Messages are Live Chat's Message objects; attachment links
// expire after 1 hour, so they are fetched on open.
const Attachment = ({ type, attachment }) => {
  if (type === "image") {
    return (
      <a href={attachment.url} target="_blank" rel="noreferrer">
        <img src={attachment.thumbnail_url || attachment.url} alt={attachment.filename} style={{ maxWidth: 240 }} />
      </a>
    );
  }
  if (type === "video") {
    return <video src={attachment.url} poster={attachment.thumbnail_url} controls style={{ maxWidth: 320 }} />;
  }
  return (
    <a href={attachment.url} target="_blank" rel="noreferrer">
      {attachment.filename}
    </a>
  );
};

const LivechatTranscript = ({ cookies, conversationId, livechatTicketId }) => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(null);

  useEffect(() => {
    serviceGetLivechatTicketTranscript(cookies.SIDikey, conversationId, livechatTicketId).then((response) => {
      setIsLoading(false);
      if (response.status === 200) {
        setMessages(response.data);
      } else {
        setErrorStatus(response.status);
      }
    });
  }, [cookies.SIDikey, conversationId, livechatTicketId]);

  if (isLoading) return <>Loading</>;
  if (errorStatus === 403) return <p className="text-danger">Anda tidak punya akses ke percakapan Live Chat ini</p>;
  if (errorStatus) return <p className="text-danger">Gagal memuat transkrip Live Chat</p>;

  return (
    <SimpleBar className="nk-chat-panel" style={{ height: "400px" }}>
      {messages.map((item) => (
        <div key={item.id} className={`chat ${item.sender.type === "agent" ? "is-me" : "is-you"}`}>
          <div className="chat-content">
            <div className="chat-bubbles">
              <div className="chat-bubble">
                <div className="chat-msg">
                  {item.deleted_at ? (
                    <i>Pesan ditarik</i>
                  ) : (
                    <>
                      {item.reply_to && (
                        <div className="border-left pl-2 mb-1 small text-soft">
                          {item.reply_to.deleted ? <i>Pesan ditarik</i> : item.reply_to.text}
                        </div>
                      )}
                      {item.attachment && <Attachment type={item.type} attachment={item.attachment} />}
                      {item.text && <div style={{ whiteSpace: "pre-wrap" }}>{item.text}</div>}
                    </>
                  )}
                </div>
              </div>
            </div>
            <ul className="chat-meta">
              <li>{item.sender.type === "agent" ? item.sender.id : item.source}</li>
              <li>{moment(item.created_at).format("DD/MM/YYYY HH:mm")}</li>
            </ul>
          </div>
        </div>
      ))}
      {messages.length === 0 && <p className="text-center text-soft">Belum ada pesan</p>}
    </SimpleBar>
  );
};

export default LivechatTranscript;
